import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addQuestion = async (bodyData) => {
  try {
    const res = await api.add_question(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteQuestion = async (id) => {
  try {
    const res = await api.delete_question(id);
    return res?.data
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error
  }
}